import { Component, OnDestroy, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { Subject } from 'rxjs';
import { ColumnSettings } from 'src/app/models/column-settings';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-lt-column-chooser',
  templateUrl: './lt-column-chooser.component.html',
  styleUrls: ['./lt-column-chooser.component.scss'],
  imports: [
    MatIconModule,
    MatButtonModule,
    CommonModule,
    MatListModule,
    MatCheckboxModule,
    DragDropModule,
    MatTooltipModule,
  ],
})
export class LtColumnChooserComponent implements OnDestroy {

  componentDestroyed$ = new Subject<boolean>();
  @Output() columnsChanged = new EventEmitter<ColumnSettings[]>();
  @Output() closeDialog = new EventEmitter<any>();

  @Input() set columns(value: ColumnSettings[]) {
    this.reorderedColumns = value.map((col) => ({ ...col }));
    this.originalColumns = value.map((col) => ({ ...col }));
  }
  public selectedColumn: ColumnSettings | null = null;
  private originalColumns: ColumnSettings[] = [];
  reorderedColumns: ColumnSettings[] = [];

  constructor(private ngZone: NgZone) { }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  reset(): void {
    this.reorderedColumns = [...this.originalColumns];
  }

  cancel(): void {
    this.closeDialog.emit(true);
  }

  apply(): void {
    this.originalColumns = [...this.reorderedColumns];
    this.columnsChanged.emit(this.reorderedColumns);
  }

  drop(event: CdkDragDrop<ColumnSettings[]>) {
    moveItemInArray(this.reorderedColumns, event.previousIndex, event.currentIndex);
  }

  selectItem(item: any) {
    this.selectedColumn = this.selectedColumn === item ? null : item;
  }

  // material - button actions - move up
  moveUp(): void {
    if (this.selectedColumn != null && this.selectedColumn != undefined) {
      const index = this.reorderedColumns.indexOf(this.selectedColumn);
      if (index > 0) {
        [this.reorderedColumns[index - 1], this.reorderedColumns[index]] = [this.reorderedColumns[index], this.reorderedColumns[index - 1]];
      }
    }
  }

  // material - button actions - move to top
  moveToTop(): void {
    if (this.selectedColumn != null && this.selectedColumn != undefined) {
      const index = this.reorderedColumns.indexOf(this.selectedColumn);
      if (index > 0) {
        const [item] = this.reorderedColumns.splice(index, 1);
        this.reorderedColumns.unshift(item);
      }
    }
  }

  // material - button actions - move down
  moveDown(): void {
    if (this.selectedColumn != null && this.selectedColumn != undefined) {
      const index = this.reorderedColumns.indexOf(this.selectedColumn);
      if (index < this.reorderedColumns.length - 1) {
        [this.reorderedColumns[index + 1], this.reorderedColumns[index]] = [this.reorderedColumns[index], this.reorderedColumns[index + 1]];
      }
    }
  }

  // material - button actions - move to buttom
  moveToBottom(): void {
    if (this.selectedColumn != null && this.selectedColumn != undefined) {
      const index = this.reorderedColumns.indexOf(this.selectedColumn);
      if (index > -1 && index < this.reorderedColumns.length - 1) {
        const [item] = this.reorderedColumns.splice(index, 1);
        this.reorderedColumns.push(item);
      }
    }
  }
}
